import { Event as GraphEvent } from '@antv/g-base';
/**
 *
 * @param group åç»
 * @param eventName äºä»¶å
 * @param eventObject äºä»¶å¯¹è±¡
 */
export function propagationDelegate(group, eventName, eventObject) {
    var event = new GraphEvent(eventName, eventObject);
    event.target = group;
    event.propagationPath.push(group); // ä»å½å group å¼å§è§¦å delegation
    group.emitDelegation(eventName, event);
    var parent = group.getParent();
    // æ§è¡åæ³¡
    while (parent) {
        // å§æäºä»¶è¦åè§¦å
        parent.emitDelegation(eventName, event);
        event.propagationPath.push(parent);
        parent = parent.getParent();
    }
}
//# sourceMappingURL=event.js.map